import React, {useEffect, useMemo, useState} from "react";
import {DefaultInfoV1Props, DefaultNavTextFieldProps, DefaultNavTextFieldV2Props} from "@models/DefaultProps.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {TextFieldNav} from "@shared/custom/TextFieldNav.tsx";
import {_Sitemap} from "@localization/siteMap/breadcrumbs/_Sitemap.ts";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";

export interface UsuarioInfoProps extends Pick<DefaultInfoV1Props<IUsuario>, 'value'>, Pick<DefaultNavTextFieldV2Props<IUsuario>, 'displayValue' | 'label'> {
    slotProps?: DefaultNavTextFieldProps<IUsuario>['slotProps'],
    events?: {
        onClick?: (v: IUsuario) => void,
    }
}

export function UsuarioInfoTextField(props: UsuarioInfoProps & { refId?: number }) {
    const {value, label, displayValue, refId} = props;
    const {tryGet} = useUsuario()
    const [usuario, setUsuario] = useState<IUsuario | undefined>(value);

    useEffect(() => {
        if (usuario == null && refId != null) {
            tryGet({id: refId}).then(x => setUsuario(x))
        }
    }, [usuario, refId]);

    const toDisplay = useMemo(() => {
        if (usuario == null) return '';
        if (displayValue != null) return displayValue(usuario);
        return usuario.nome;
    }, [usuario, displayValue])

    return (usuario != null && <TextFieldNav label={label ?? 'Usuario'}
                                             displayValue={toDisplay}
                                             slotProps={{textField: props.slotProps?.textField}}
                                             onClick={props.events?.onClick}
                                             pathName={_Sitemap.usuarios.children.detalhes.fullUrl}
                                             searchData={{usuarioId: usuario.id}}/>);
}